import React, { useContext, createContext } from 'react'
import { useIntl } from 'react-intl'
import Headline from '@atoms/Headline/Headline'
import {
  ToggleCardWrapper,
  ToggleCardHeader,
  ToggleCardContent,
  ToggleCardNumber
} from './ToggleCard.partials'
import { ToggleCardItemsProps, ToggleCardProps } from './ToggleCard.types'

const defaultProviderValue = {
  editing: false,
  disabled: false
}

const ToggleCardContext = createContext(defaultProviderValue)

export const ToggleCard = ({
  currentStep,
  maxStep,
  title,
  editing,
  disabled,
  onEdit,
  editButtonIcon,
  id,
  children
}: ToggleCardProps) => {
  const { formatMessage } = useIntl()

  return (
    <ToggleCardContext.Provider value={{ editing, disabled }}>
      <ToggleCardWrapper
        classNames={`${(editing && ' edit-mode') || ''}`}
        id={id}
      >
        <ToggleCardHeader>
          {currentStep && maxStep && (
            <ToggleCardNumber current={currentStep} max={maxStep} />
          )}
          <Headline tag='h2' className='headline-h5'>
            {title}
          </Headline>
          {(!editing && !disabled && onEdit && (
            <button className='edit-link' onClick={onEdit}>
              {editButtonIcon ||
                formatMessage({
                  defaultMessage: 'Edit',
                  id: 'msp.checkout.edit'
                })}
            </button>
          )) ||
            null}
        </ToggleCardHeader>
        <ToggleCardContent>{children}</ToggleCardContent>
      </ToggleCardWrapper>
    </ToggleCardContext.Provider>
  )
}

export const ToggleCardEdit = ({ children }: ToggleCardItemsProps) => {
  const { editing } = useContext(ToggleCardContext)
  return editing ? children : null
}

export const ToggleCardSummary = ({ children }: ToggleCardItemsProps) => {
  const { editing, disabled } = useContext(ToggleCardContext)
  return !editing && !disabled ? (
    <div className='summary'>{children}</div>
  ) : null
}
